import { PropsRadioButton } from './PropsRadioButton';
import classNames from 'classnames';

import styles from './RadioButton.module.scss';

export const RadioButton = ({ children, reg, ...props }: PropsRadioButton): JSX.Element => {
  return (
    <div className={classNames(styles.RadioButton, props.disabled && styles.Disable)}>
      <input type="radio" {...props} {...reg} />
      <span className={styles.checked}></span>
      <label htmlFor={props?.id}>{children}</label>
    </div>
  );
};
